import { call, put, takeEvery } from 'redux-saga/effects';

import { templatesActions } from '../actions/templates';
import * as api from '../api/templates';

const { templatesRender, templatesRenderSucceeded, templatesRenderFailed } =
  templatesActions;

export const templates = [
  takeEvery(
    templatesRender.toString() as any,
    genWithPromise(api.render, templatesRenderSucceeded, templatesRenderFailed),
  ),
];

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}
